(() => {
 const grid = document.querySelector('.gh-catalogue-grid');
 if (grid) {
  const cards = [...grid.querySelectorAll('.gh-card')];
  const slug = value => value.toLowerCase().trim().replace(/\s+/g, '-');
  const filter = () => {
   const requested = location.hash.slice(1) || 'all';
   const known = ['all','lighting','planters','outdoor-living','garden-essentials'];
   const category = known.includes(requested) ? requested : 'all';
   cards.forEach(card => card.hidden = category !== 'all' && slug(card.dataset.category) !== category);
   document.querySelectorAll('[data-filter]').forEach(link => link.setAttribute('aria-current', String(link.dataset.filter === category)));
  };
  window.addEventListener('hashchange',filter); filter();
  document.querySelector('#gh-sort')?.addEventListener('change', event => {
   const sorted = [...cards];
   if(event.target.value === 'low') sorted.sort((a,b)=>Number(a.dataset.price)-Number(b.dataset.price));
   if(event.target.value === 'high') sorted.sort((a,b)=>Number(b.dataset.price)-Number(a.dataset.price));
   if(event.target.value === 'az') sorted.sort((a,b)=>a.dataset.title.localeCompare(b.dataset.title));
   sorted.forEach(card=>grid.append(card));
  });
 }
 document.querySelector('#gh-variant')?.addEventListener('change', event => {
  const url = new URL(location.href); url.searchParams.set('variant',event.target.value);location.assign(url.href);
 });
 document.querySelectorAll('.gh-mobile-menu nav a').forEach(a=>a.addEventListener('click',()=>a.closest('details').removeAttribute('open')));
})();
